package com.example.monetix

import com.example.monetix.db.*

const val TYPE_EXPENSE = "EXPENSE"
const val TYPE_INCOME = "INCOME"
const val TYPE_TRANSFER = "TRANSFER"

enum class ThemeMode {
    SYSTEM, LIGHT, DARK
}

/**
 * Calcola il saldo contabile reale per ogni conto basandosi sulle transazioni.
 */
fun computeAccountingBalancesById(
    accounts: List<AccountEntity>,
    transactions: List<TransactionEntity>
): Map<String, Long> {
    val balances = mutableMapOf<String, Long>()

    // Inizializza a zero
    accounts.forEach { balances[it.id] = 0L }

    // Somma/Sottrai transazioni
    transactions.filter { !it.isDeleted }.forEach { tx ->
        when (tx.type) {
            TYPE_INCOME -> tx.accountId?.let { id -> balances[id] = (balances[id] ?: 0) + tx.amountCents }
            TYPE_EXPENSE -> tx.accountId?.let { id -> balances[id] = (balances[id] ?: 0) - tx.amountCents }
            TYPE_TRANSFER -> {
                tx.fromAccountId?.let { id -> balances[id] = (balances[id] ?: 0) - tx.amountCents }
                tx.toAccountId?.let { id -> balances[id] = (balances[id] ?: 0) + tx.amountCents }
            }
        }
    }
    return balances
}

/**
 * Funzione segnaposto per la sincronizzazione automatica (rate e ricorrenti).
 */
suspend fun autoSyncAllMovements(database: MonetixDatabase): Int {
    // La logica di generazione automatica la inseriremo in seguito
    return 0
}